<template lang="pug">
    .heading-container(:class="[spacingTop, spacingBottom, headingLayout ]")
      .container.mx-auto(:class="{ 'text-center': textAlignment === 'center' }")
        component(v-if="heading" :is="headingTag" :class="classes.heading") {{ heading }}
        component(v-if="subHeading" :is="subHeadingTag" :class="classes.subHeading") {{ subHeading }}

</template>

<script>
// import _ from 'lodash'
import get from 'lodash.get';

export default {
    name: 'Heading',
    props: {
        section: {
            type: Object,
            required: true
        },
        headingTag: {
            type: String,
            default: 'h2'
        },
        headingClass: {
            type: String,
            default: 'title regular'
        },
        subHeadingTag: {
            type: String,
            default: 'h3'
        },
        subHeadingClass: {
            type: String,
            default: 'subtitle regular'
        }
    },
    computed: {
        heading() {
            return get(this.section, 'contents.0.title');
        },
        subHeading() {
            return get(this.section, 'contents.0.sub_title');
        },
        textAlignment() {
            let alignment = 'left';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment');
                if (setting && setting.value !== undefined) alignment = setting.value;
            }

            return alignment;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        headingLayout() {
            let headingLayout = 'layout1';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'headingLayout');
                if (setting && setting.value !== undefined) headingLayout = setting.value;
            }
            return headingLayout;
        },

        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass
            };

            const settings = get(this.section.contents[0], 'settings') || [];
            const titleSize = settings.find(setting => setting.key === 'title_size');
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size');

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'small':
                        classes.heading = 'title small';
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'title regular';
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'small':
                        classes.subHeading = 'subtitle small';
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'subtitle regular';
                }
            }

            return classes;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.heading-container
    font-family: $font
    &.layout1,
    &.layout2,
    &.layout3
        .title
            &.regular
                font-size: 20px
                line-height: 32px
                @screen sm
                    font-size: 28px
                    line-height: 40px
                @screen lg
                    font-size: 36px
                    line-height: 48px
            &.small
                font-size: 12px
                line-height: 24px
                @screen sm
                    font-size: 16px
                    line-height: 28px
                @screen lg
                    font-size: 20px
                    line-height: 32px
        .subtitle
            &.regular
                font-size: 15px
                line-height: 22px
                @screen sm
                    font-size: 18px
                    line-height: 30px
                @screen lg
                    font-size: 22px
                    line-height: 34px
            &.small
                font-size: 12px
                line-height: 16px
                @screen sm
                    font-size: 14px
                    line-height: 22px
                @screen lg
                    font-size: 16px
                    line-height: 26px
    &.layout1
        .title
            @apply font-bold
            color: $cc-blue
        .subtitle
            @apply font-semibold
            color: $cc-green
    &.layout2
        @apply flex justify-center items-center text-black
        min-height: 100px
        background-color: $cc-grey
        @screen sm
            min-height: 150px
        @screen lg
            min-height: 250px
        .title
            @apply font-bold
            margin-bottom: 8px
        .subtitle
            @apply font-light
    &.layout3
        color: $cc-font-base
        text-align: center
        .title
            @apply font-bold
            margin-bottom: 8px
            width: 35%
            margin: 0 auto
            padding-bottom: 10px
            border-bottom: 1px solid #ddd
            @screen lg
                padding-bottom: 20px
        .subtitle
            padding-top: 20px
            @apply font-light
    &.layout4
        color: $cc-blue
        font-weight: bold
        .title
            &.regular
                font-size: 15px
                line-height: 22px
                @screen sm
                    font-size: 18px
                    line-height: 30px
                @screen lg
                    font-size: 22px
                    line-height: 34px
            &.small
                font-size: 12px
                line-height: 16px
                @screen sm
                    font-size: 14px
                    line-height: 22px
                @screen lg
                    font-size: 16px
                    line-height: 26px
        .subtitle
            &.regular
                font-size: 13px
                line-height: 20px
                @screen sm
                    font-size: 16px
                    line-height: 28px
                @screen lg
                    font-size: 20px
                    line-height: 31px
            &.small
                font-size: 10px
                line-height: 14px
                @screen sm
                    font-size: 12px
                    line-height: 20px
                @screen lg
                    font-size: 14px
                    line-height: 18px
</style>
